import { FC } from 'react';
import cx from 'classnames';

import { SvgIcon } from '@/components';

import styles from './SidebarNavButton.module.sass';

interface SidebarNavButtonProps {
  iconName: string;
  text: string;
  onClick: () => void;
  className?: string;
}

const SidebarNavButton: FC<SidebarNavButtonProps> = ({
  iconName,
  text,
  onClick,
  className,
}) => {
  const classes = cx(styles.button, className);

  return (
    <button type="button" className={classes} onClick={onClick}>
      <SvgIcon name={iconName} className={styles.icon} />
      <span className={styles.text}>{text}</span>
    </button>
  );
};

export default SidebarNavButton;
